import * as React from 'react';
import { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useAuthContext } from '@web/api/src';

// const ROLES = ['admin', 'farmer'] as const;

// type Role = (typeof ROLES)[number];

export function UserAuthGuard({ children }) {
  const auth = useAuthContext();
  const location = useLocation();

  useEffect(() => {
    const checkUser = () => {
      if (!auth.jwt) {
        auth.login(location.pathname);
      }
      // Update isAllowed and loading if necessary
    };
    checkUser();
  }, [auth, location]);

  return <>{children}</>;
}
